import DefaultView from "./DefaultView.vue";

export default DefaultView;